import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=e4225e20"
import script from "./ActiveFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveFilters.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ActiveFilters.vue?vue&type=style&index=0&id=e4225e20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports